import React from 'react';

// A reusable button component for consistent styling
const ActionButton = ({ onClick, children, className = '', disabled = false, title = '' }) => (
  <button
    title={title}
    onClick={onClick}
    disabled={disabled}
    className={`w-full bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 ease-in-out disabled:bg-gray-400 disabled:cursor-not-allowed ${className}`}
  >
    {children}
  </button>
);

export default ActionButton;